export type SubmitContext = {
  emptyFeatureFields: unknown[]
  hasVisitedFeatureTab: boolean
  isSoja: boolean
}

export const shouldAskNoInformation = ({
  emptyFeatureFields,
  hasVisitedFeatureTab,
  isSoja,
}: SubmitContext) => emptyFeatureFields.length > 0 && hasVisitedFeatureTab && isSoja
